import { connect, MapStateToProps } from 'react-redux'
import selectedCarlineTitleSelector from '../../redux/selectors/carlines/selectedCarlineTitleSelector'
import { Props } from './ModelSelection'
import modelsLoadedSelector from '../../redux/selectors/models/modelsLoadedSelector'
import modelSelectionIsLoadingSelector from '../../redux/selectors/is-loading/modelSelectionIsLoadingSelector'
import cartIsVisibleSelector from '../../redux/selectors/cart/cartIsVisibleSelector'
import filtersAreVisibleSelector from '../../redux/selectors/filtersAreVisibleSelector'
import modelsPageFiltersEnabledSelector from '../../redux/selectors/modelsPageFiltersEnabledSelector'
import { toggleFiltersAreVisible } from '../../redux/actions/app/carlineSelection.actions'

type StateProps = Pick<Props, 'modelsLoaded' | 'carlineTitle' | 'isLoading' | 'cartIsVisible' | 'filtersAreVisible' | 'modelFiltersEnabled'>

type DispatchProps = Pick<Props, 'toggleFiltersAreVisible'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    modelsLoaded: modelsLoadedSelector(state),
    carlineTitle: selectedCarlineTitleSelector(state),
    isLoading: modelSelectionIsLoadingSelector(state),
    cartIsVisible: cartIsVisibleSelector(state),
    filtersAreVisible: filtersAreVisibleSelector(state),
    modelFiltersEnabled: modelsPageFiltersEnabledSelector(state),
})

const mapDispatchToProps: DispatchProps = {
    toggleFiltersAreVisible,
}

export default connect(mapStateToProps, mapDispatchToProps)
